export const QUERY__REPORTS = 'reports';
